import React from 'react';

import cx from 'classnames';
import { useSelector } from 'react-redux';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import BackLink from 'components/Layouts/Form/Header/shared/BackLink';
import MainHeader from 'components/Layouts/shared/MainHeader';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import { isMovingBlockedSelector } from 'store/movingBlocked/selectors';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';
import { useItinerariesItemContext } from 'utils/itineraries/context';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { ITINERARIES_ITEM_TYPE_TO_STEP_LABEL_MAP } from 'utils/itineraries/map';

import baseStyles from '../index.module.css';

function ItinerariesItemHeader() {
  const {
    steps,
    backButton: { link, text, isSSR = false },
    itemId,
    isCreating,
    itemType,
  } = useItinerariesItemContext();
  const item = useSelector(itinerariesItemDataSelector);
  const doesItineraryHaveChanges = useSelector(appHasChangesSelector);
  const indexOfLastAvailableStep = item.lastAvailableStep ? steps.indexOf(item.lastAvailableStep) : 0;
  const getItinerariesItemPath = useItinerariesItemStepPath(itemType);
  const isMovingBlocked = useSelector(isMovingBlockedSelector);

  return (
    <MainHeader
      backLink={
        <BackLink isSSR={isSSR} href={link}>
          {text}
        </BackLink>
      }
      links={steps.map((step, index) => {
        const label = ITINERARIES_ITEM_TYPE_TO_STEP_LABEL_MAP[itemType][step];
        const isDisabled =
          doesItineraryHaveChanges ||
          isMovingBlocked ||
          index > indexOfLastAvailableStep ||
          (isCreating && index !== 0);

        return (
          <ItemLink
            key={label}
            href={getItinerariesItemPath(step, itemId)}
            noMargin
            className={cx(baseStyles.link, { [baseStyles.disabled]: isDisabled })}
            linkClassName={baseStyles.tab}
            disabled={isDisabled}
            children={label}
          />
        );
      })}
    />
  );
}

export default ItinerariesItemHeader;
